import { GetConsentVersions, GetConsentVersionsResponse } from "@/api/dtos";
import { useGet } from "@ngt/opms";
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";


export const PICF_VERSION_OTHER_ID = 0;

const getData = (response?: SWRResponse<GetConsentVersionsResponse, GetConsentVersionsResponse>) => response?.data?.consentPicfs;

const getError = (response?: SWRResponse<GetConsentVersionsResponse, GetConsentVersionsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useConsentVersions = (institutionCode?: string, picfTypeName?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return institutionCode && picfTypeName ?
            () => {
                return new GetConsentVersions({ institutionCode, picfTypeName });
            } :
            undefined;
    }, [institutionCode, picfTypeName])

    return useGet(request, { getData, getError }, configuration);
};

export default useConsentVersions;